import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { Alert, Button } from "reactstrap";
import QRCode from "react-qr-code";
import { loadTrainingResults } from "../../../utils/Api";
import { toLocalTime, getTextFromHtml } from "../../../utils/helper";

import { isLocal, domain } from "../../../config";

const path = isLocal ? "//localhost:3002/#" : `${domain}/company/#`;

const mapStateToProps = ({ user }) => ({
  permissions: user.permissions || [],
  allow_chat: user.options && user.options.allow_chat,
  hide_links_on_learning: user.options && user.options.hide_links_on_learning,
});

class Results extends React.Component {
  constructor(props) {
    super(props);

    this.id = +props.match.params.id;
    this.state = {
      errorMessage: "",
      qrCode: "",
    };
  }

  componentDidMount() {
    (async () => {
      const response = await loadTrainingResults(this.id).then((r) => r);
      if (response.error) {
        this.setState({ errorMessage: response.error.msg });
      } else {
        this.setState({ ...response });
        if (response.c_file_link) {
          const url = response.c_file_link;
          this.setState({ qrCode: url });
        }
      }
    })();
  }

  render() {
    const { intl, permissions, allow_chat, hide_links_on_learning } = this.props;
    if (!permissions.includes("TRAINING_STATISTICS")) {
      return null;
    }

    const {
      training_title,
      training_description,
      trainer_firstname,
      trainer_lastname,
      training_started,
      training_finished,
      storage_id,
      file_link,
      original_name,
      size,
      c_storage_id,
      c_file_link,
      c_original_name,
      c_size,
      lessons_count,
      lessons_passed,
      lessons_failed,
      successfully_passed,
      errorMessage,
    } = this.state;

    return (
      <React.Fragment>
        {!hide_links_on_learning &&
        <div className="category_block">
          <ul>
            {allow_chat && (
              <li className="category">
                <Link to="/trainings/chats">
                  <i className="icon_c icon_c_bg icon_chats" />
                  <FormattedMessage id="routes_chats" />
                </Link>
              </li>
            )}
            <li className="category">
              <a href={`${path}/reports/users`}>
                <i className="icon_c icon_c_bg icon_reports" />
                <FormattedMessage id="routes_reports" />
              </a>
            </li>
            <li className="category">
              <Link to="/trainings/notes">
                <i className="icon_c icon_c_bg icon_notes" />
                <FormattedMessage id="routes_notes" />
              </Link>
            </li>
            <li className="category">
              <Link to="/trainings/pictures">
                <i className="icon_c icon_c_bg icon_images" />
                <FormattedMessage id="routes_pictures" />
              </Link>
            </li>
            <li className="category">
              <Link to="/trainings/certificates">
                <i className="icon_c icon_c_bg icon_cert" />
                <FormattedMessage id="routes_certificates" />
              </Link>
            </li>
          </ul>
        </div>
        }
        <div className="main_content">
          <section>
            <div className="content" style={{ position: "relative" }}>
              {errorMessage ? (
                <Alert color="danger">
                  <FormattedMessage id={errorMessage} />
                </Alert>
              ) : (
                <React.Fragment>
                  <div style={{ position: "absolute", right: 40 }}>
                    {/* <img src={this.state.qrCode} alt="QR_code" /> */}
                    <QRCode
                      size={200}
                      style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                      value={this.state.qrCode}
                      viewBox={`0 0 200 200`}
                    />
                  </div>
                  <div>
                    <FormattedMessage
                      id="mytrainings_results_training"
                      values={{ text: getTextFromHtml(training_title) }}
                    />
                  </div>
                  {/* <div>Training: {training_description}</div> */}
                  <div>
                    <FormattedMessage
                      id="mytrainings_results_trainer"
                      values={{
                        firstname: trainer_firstname,
                        lastname: trainer_lastname,
                      }}
                    />
                  </div>
                  <div>
                    <FormattedMessage
                      id="mytrainings_results_startDate"
                      values={{
                        text:
                          toLocalTime(training_started) ||
                          intl.formatMessage({
                            id: "mytrainings_results_notStarted",
                          }),
                      }}
                    />
                  </div>
                  <div>
                    <FormattedMessage
                      id="mytrainings_results_endDate"
                      values={{
                        text:
                          toLocalTime(training_finished) ||
                          intl.formatMessage({
                            id: "mytrainings_results_notFinished",
                          }),
                      }}
                    />
                  </div>
                  <div>
                    <FormattedMessage
                      id="mytrainings_results_lessonsTotal"
                      values={{ count: lessons_count }}
                    />
                  </div>
                  <div>
                    <FormattedMessage
                      id="mytrainings_results_lessonsPassed"
                      values={{ count: lessons_passed }}
                    />
                  </div>
                  <div>
                    <FormattedMessage
                      id="mytrainings_results_lessonsFailed"
                      values={{ count: lessons_failed }}
                    />
                  </div>
                  <div style={{ width: 500 }}>
                    {successfully_passed ? (
                      <Alert color="success">
                        <FormattedMessage id="mytrainings_results_youPassed" />
                      </Alert>
                    ) : (
                      <Alert color="danger">
                        <FormattedMessage id="mytrainings_results_youFailed" />
                      </Alert>
                    )}
                  </div>
                  <div className="mt-3">
                    {c_file_link && (
                      <a href={c_file_link}>
                        <Button
                          color="primary"
                          disabled={
                            !permissions.includes("MY_CERTIFICATES_DOWNLOAD")
                          }
                        >
                          <FormattedMessage
                            id={
                              successfully_passed
                                ? "mytrainings_results_downloadCompletion"
                                : "mytrainings_results_downloadParticipant"
                            }
                          />
                        </Button>
                      </a>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

Results.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  match: PropTypes.objectOf(PropTypes.any),
  allow_chat: PropTypes.bool,
};

export default connect(mapStateToProps)(injectIntl(Results));



// WEBPACK FOOTER //
// ./src/views/_MyTrainings/Results/index.js